import { Outlet, useLocation } from 'react-router-dom';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { useActiveVerseStore } from '@/verse/active-verse.store';
import { VerseSessionInitializer } from '@/verse/VerseSessionInitializer';
import { ErrorBoundary } from './ErrorBoundary';
import { Sidebar } from './Sidebar';

export function Layout() {
  const switching = useActiveVerseStore((s) => s.switching);
  const activeVerseId = useActiveVerseStore((s) => s.activeVerseId);
  const connectionError = useActiveVerseStore((s) => s.connectionError);
  const location = useLocation();
  return (
    <div className="flex h-screen bg-background text-foreground">
      <VerseSessionInitializer />
      <Sidebar />
      <main className="flex-1 overflow-y-auto p-8">
        {switching ? (
          <p className="text-sm text-muted-foreground">Connecting to verse…</p>
        ) : connectionError ? (
          <Alert variant="destructive" className="max-w-3xl">
            <AlertTitle>Failed to connect to verse</AlertTitle>
            <AlertDescription>
              <pre className="whitespace-pre-wrap break-all font-mono text-xs">
                {connectionError}
              </pre>
              <p className="text-muted-foreground">
                사이드바의 Verse 셀렉터에서 다른 verse 를 선택해 보세요. 토큰이 만료된 경우엔 좌측
                하단 Sign out 후 새 토큰으로 다시 로그인하세요.
              </p>
            </AlertDescription>
          </Alert>
        ) : !activeVerseId ? (
          <p className="text-sm text-muted-foreground">
            No active verse. Pick one from the sidebar.
          </p>
        ) : (
          <ErrorBoundary key={location.pathname}>
            <Outlet />
          </ErrorBoundary>
        )}
      </main>
    </div>
  );
}
